<template>
    <section>
        <b-overlay :show="loading" rounded="sm">
            <!---<select v-model="showing">
                <option value="9">Top 10</option>
                <option value="4">Top 5</option>
                <option value="2">Top 3</option>
                <option value="all" selected>Show All</option>
            </select>--->
            <chart :options="chartOptions"  ref="chart"></chart>
            <!---<span>Total :{{totalRides}}</span>--->
        </b-overlay>

    </section>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts'
    import exportingInit from 'highcharts/modules/exporting'
	import loadDrillDown from 'highcharts/modules/drilldown'
	loadDrillDown(Highcharts)
    exportingInit(Highcharts)

    export default {
        name: "BarGraph",
        components:{Chart},
        props: {
			chartOptionsProp: {
                type : Object,
                required: false
            },
        },
        data(){
            let seriesExample = [{
                name:"",
				data: [],
				dataLabels: {
					enabled: true,
					rotation: -90,
					color: '#FFFFFF',
					align: 'right',
					format: '{point.y:.1f}', // one decimal
					y: 10, // 10 pixels down from the top
					style: {
						fontSize: '13px',
						fontFamily: 'Verdana, sans-serif'
					}
				}
			}];

            return {
                showing:"all",
                loading:false,
                exporting: {
                    enabled: true
                },
                chartOptions:{
					chart: {
						type: ''
					},
                    title: {
                        text: ''
                    },
                    tooltip: {
                        formatter: function(tooltip) {
                            let original = tooltip.defaultFormatter.call(this, tooltip);
                            return original;
                        }
                    },
                    yAxis: {
						min: 0,
						title: {
							text: ''
						}
					},
                    exporting:{
                        buttons:{
                            menuItems:["viewFullscreen"]
                        }
                    },
					xAxis:{
						type: 'category',
                        labels: {
							autoRotation: [-45, -90],
							style: {
								fontSize: '13px',
								fontFamily: 'Verdana, sans-serif'
							}
						}
                    },
					series: seriesExample
                }
            }
        },
        methods:{
			setChartOptions(chartOptions){
				this.chartOptions = {...this.chartOptions,...chartOptions}
			}
        },
        watch:{
            showing(){
                if(this.showing >0 ){
                    if((this.showing)<= (this.chartOptions.xAxis.categories.length-1) ){
                        this.chartOptions.xAxis.max= this.showing;
                    }else{
                        this.showing = 'all';
                    }
                }else{
                    this.chartOptions.xAxis.max = null;
                }
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>
